import { observer } from 'mobx-react'
import { TrackingFlag } from '../../tracking/TrackingContent'
import { ReactComponent as Arrow } from '../../../../assets/login/Rectangle 30.svg'
import { useEffect, useRef, useState } from 'react'
import './index.scss'
import classNames from 'classnames'
const LangList = observer(
  ({
    state,
    setState,
    dt,
  }: {
    state: any
    setState: (value: any) => void
    dt: any
  }) => {
    const [isShow, setShow] = useState(false)
    const [langs, setLangs] = useState<any>(null)
    const ref = useRef<any>(null)

    const isInside = (e: Event) => {
      if (!ref.current) return false
      if (!(ref.current as any).contains(e.target)) {
        setShow(false)
      } else return false
    }

    useEffect(() => {
      if (!ref.current) return
      const parent = document.querySelector('.coop-pop__container')
      if (!parent) {
        window.addEventListener('click', (e) => isInside(e))
      } else {
        parent.addEventListener('click', (e) => isInside(e))
      }

      return () => {
        parent && parent.removeEventListener('click', (e) => isInside(e))
      }
    }, [])

    useEffect(() => {
      setLangs(dt)
    }, [])
    return (
      <div className={classNames('personal-lang', isShow && 'show')} ref={ref}>
        <div className="personal-lang__top" onClick={() => setShow(true)}>
          {' '}
          <div className="personal-lang__flag">
            <img src={state.icon} />
          </div>
          <span> {state.lang}</span>
          <Arrow />
        </div>
        <div className="personal-lang__list">
          {langs?.map((l: any, i: number) => (
            <div
              className="personal-lang__item"
              key={i}
              onClick={() => {
                setState({
                  lang: l.country,
                  icon: l.flag,
                })
                setShow(false)
              }}
            >
              <div className="personal-lang__flag">
                <img src={l.flag} />
              </div>
              {l.country}
            </div>
          ))}
        </div>
      </div>
    )
  },
)
export default LangList
